import { render, staticRenderFns } from "./Overseas.vue?vue&type=template&id=20e71bf6&scoped=true&"
import script from "./Overseas.vue?vue&type=script&lang=js&"
export * from "./Overseas.vue?vue&type=script&lang=js&"
import style0 from "./Overseas.vue?vue&type=style&index=0&id=20e71bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e71bf6",
  null
  
)

export default component.exports